/* eslint-disable no-self-assign */
import Axios from "axios";
import { action, decorate, observable } from "mobx";
import ServerGridConfig from "../../../../config/ServerGridConfig";
import moment from "moment";

export default class AccountBookingSendEmailStore {
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	current_page = 1;
	list_data = null;
	total = 0;
	allColumnIds = [];
	fromDate = moment().format("YYYY-MM-DD");
	toDate =  moment().format("YYYY-MM-DD");
	apiRes = null;
	formPayload = null;
	isSelectAll = false;
	selectCount = 0;
	visibleRowCount = 0;
	selectedRowCount = 0;
	selectAllArr = []

	setIsSelectAll = (data) => {
		this.isSelectAll = data
	}

	setFormPayload = data => {
		this.formPayload = data
	}

	refreshList = () => {
		if (this.agGrid) {
			this.setupGrid(this.agGrid);
		}
	}

	setVisibleRowCount = (data) => {
		this.visibleRowCount = data;
	}

	setSelectedRowCount = (data) => {
		this.selectedRowCount = data;
	}

	setSelectAllArr = (data) => {
		this.selectAllArr = data
	}

	// Setup grid and set column size to autosize
	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		if (this.fromDate && this.toDate) {
			this.agGrid.api.setFilterModel({
				date: { dateFrom:this.fromDate, dateTo: this.toDate, type: "inRange", filterType: "date" }
			});			
		}
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};

	// change page size, default page size is LocalGridConfig.options.paginationPageSize
	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.paginationSetPageSize(parseInt(page));
		}
	};

	//set list purpose
	setListCustomDate = (date_completed) => {
		this.listCustomDate = date_completed;
		const completedDate = this.listCustomDate?.[0].date_completed		
		this.fromDate = moment(completedDate?.[0]).format("YYYY-MM-DD");
		this.toDate = moment(completedDate?.[1]).format("YYYY-MM-DD");		
		this.refreshList();
	};


	// call api to get records
	getList = (payload) => {
		return Axios.post(`/bookings/account-send-email/get-data`, payload).then(({ data }) => {
			if (data.list.data.length) {
				let startPage = (data.list.current_page - 1) * data.list.per_page;
				data.list.data.map((item, index) => {
					item.srno = startPage + index + 1;
					this.setVisibleRowCount(this.visibleRowCount + 1)
					//     item.cities = item.cities && item.cities.name
					return null;
				});
			}
			if (this.visibleRowCount > 0 && this.visibleRowCount !== this.selectedRowCount) {
				this.setIsSelectAll(false)
			}
			this.list_data = data.list ? data.list.data : null;
			this.total = data.list.total;
			this.current_page = data.list.current_page;
			return data;
		});
	};

	// Call add api
	AddData = (formdata) => {
		return Axios.post(`/bookings/account-send-email/email`, formdata)
			.then(({ data }) => {
				return data
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};


	// Filter function for no record found message
	changeFilterAndSort = (params) => {
		var final_filter = params.filterModel;
		var final_sort = params.sortModel;

		return { final_filter, final_sort };
	};

	// Filter function for no record found message
	onFilterChanged = (params) => {
		this.agGrid.api.deselectAll();
		this.setVisibleRowCount(0)
		this.setSelectedRowCount(0)
		this.setSelectAllArr([])
		this.agGrid = params;
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() === 0) {
			this.agGrid.api.showNoRowsOverlay();
		}
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() > 0) {
			this.agGrid.api.hideOverlay();
		}
	};

	// Create data source to display record in table
	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			getRows: (params) => {
				var filter_data = this.changeFilterAndSort(params.request);
				var payload = {
					date_completed:{ date_from: this.fromDate, date_to:this.toDate, type: "inRange",filterType: "date" },
					filter_data: filter_data.final_filter,
					sort_data: filter_data.final_sort,
					per_page: params.request.endRow - params.request.startRow,
					page: Math.ceil(
						(params.request.startRow + 1) /
						(params.request.endRow - params.request.startRow)
					),
				};
				this.getList(payload).then((data) => {
					if (data.list.total === 0) {
						this.agGrid.api.showNoRowsOverlay();
					} else {
						this.agGrid.api.hideOverlay();
					}
					params.successCallback(data.list.data, data.list.total);
					var allColumnIds = [];
					if (this.agGrid && this.agGrid.columnApi && data.total) {
						this.agGrid.columnApi.getAllColumns().forEach(function (column) {
							allColumnIds.push(column.col_id);
						});
					}
				}).then(() => this.onFirstDataRendered());
			},
		};
	};

	onFirstDataRendered = () => {
		if (this.isSelectAll === true && this.agGrid) {
			this.agGrid.api.forEachNode((node) => {
				this.selectCount++;
				this.setSelectedRowCount(this.selectedRowCount + 1)
				node.setSelected(true);
			});
		}
	};

	onSelectAllRender = (selectAllFlag) => {
		if (selectAllFlag === true) {
			this.onFirstDataRendered();
		} else {
			this.agGrid.api.forEachNode((node) => {
				this.setSelectedRowCount(0);
				node.setSelected(false);
			});
		}
	};
}

decorate(AccountBookingSendEmailStore, {
	per_page: observable,
	agGrid: observable,
	list_data: observable,
	total: observable,
	allColumnIds: observable,
	setupGrid: action,
	setPageSize: action,
	getList: action,
	onFilterChanged: action,
	apiRes: observable,
	setFormPayload: action,
	formPayload: observable,
	isSelectAll: observable,
	onFirstDataRendered: action,
	setIsSelectAll: action,
	selectCount:observable,
	visibleRowCount: observable,
	setVisibleRowCount: action,
	selectedRowCount: observable,
	setSelectedRowCount: action,
	selectAllArr: observable,
	setSelectAllArr: action,
});
